module.exports = __webpack_public_path__ + "static/zen-light-logo-17fc609a5a5bd1108ad5783a490e193c.jpg";